import type { PaymentMethod } from '@/data/catalog/offer/interfaces';

export type RegistrationNextStep =
  | 'external_link'
  | 'institution_email'
  | 'default';

export type CheckoutPaymentFailureStage =
  | 'card_validation'
  | 'checkout_request'
  | 'payment_not_identified';

export interface EnrollmentProperties {
  course_id?: number;
  course_name?: string;
  offer_id?: number;
  institution_id?: number;
  institution_name?: string;
  price?: number;
  is_full_included?: boolean;
}

interface CouponAppliedProperties extends EnrollmentProperties {
  success: boolean;
  coupon: string;
}

export enum EnrollmentEvent {
  EnrollmentBlocked = 'Enrollment Blocked',
  RegistrationStarted = 'Registration Started',
  RegistrationCouponApplied = 'Registration Coupon Applied',
  RegistrationSubmitted = 'Registration Submitted',
  RegistrationExternalLinkClicked = 'Registration External Link Clicked',
  CheckoutStarted = 'Checkout Started',
  CheckoutStepViewed = 'Checkout Step Viewed',
  CheckoutCouponApplied = 'Checkout Coupon Applied',
  CheckoutCustomerInfoSubmitted = 'Checkout Customer Info Submitted',
  CheckoutPaymentSubmitted = 'Checkout Payment Submitted',
  CheckoutPaymentFailed = 'Checkout Payment Failed',
  CheckoutPaymentConfirmed = 'Checkout Payment Confirmed',
}

export interface EnrollmentEventProperties {
  [EnrollmentEvent.EnrollmentBlocked]: EnrollmentProperties & {
    reason: 'subscription_limit';
  };
  [EnrollmentEvent.RegistrationStarted]: EnrollmentProperties;
  [EnrollmentEvent.RegistrationCouponApplied]: CouponAppliedProperties;
  [EnrollmentEvent.RegistrationSubmitted]: EnrollmentProperties & {
    success: boolean;
    has_coupon: boolean;
    next_step?: RegistrationNextStep;
    error_reason?: string;
  };
  [EnrollmentEvent.RegistrationExternalLinkClicked]: EnrollmentProperties;
  [EnrollmentEvent.CheckoutStarted]: EnrollmentProperties;
  [EnrollmentEvent.CheckoutStepViewed]: EnrollmentProperties & {
    step: string;
    payment_method?: PaymentMethod;
  };
  [EnrollmentEvent.CheckoutCouponApplied]: CouponAppliedProperties;
  [EnrollmentEvent.CheckoutCustomerInfoSubmitted]: EnrollmentProperties & {
    success: boolean;
    error_reason?: string;
  };
  [EnrollmentEvent.CheckoutPaymentSubmitted]: EnrollmentProperties & {
    payment_method?: PaymentMethod;
    installments?: number;
    amount?: number;
    has_coupon: boolean;
  };
  [EnrollmentEvent.CheckoutPaymentFailed]: EnrollmentProperties & {
    payment_method?: PaymentMethod;
    stage: CheckoutPaymentFailureStage;
    error_reason?: string;
  };
  [EnrollmentEvent.CheckoutPaymentConfirmed]: EnrollmentProperties & {
    payment_method?: PaymentMethod;
    amount?: number;
  };
}
